import { Exchange } from '../exchange';

export type GetTopAssetsByVolumeInfo = {
  baseAsset: string;
  quoteAsset: string; // Needs to be a stable coin for now
  exchange: Exchange;
  baseVolume: number; // Needs to be sorted on this
  quoteVolume: number;
  isActive: boolean; // Show if the bot already exists
  /** Combined SPC score, present when data-service had a fresh SPC file with score. */
  score?: number;
  profits?: {
    // We would need to do a SPC for each bot in this case
    lastDay: number;
    lastWeek: number;
    lastMonth: number;
    lastYear: number;
    daily: number;
    weekly: number;
    monthly: number;
    yearly: number;
  };
};

export enum TimeFrame {
  TwoMonths = '2M',
  OneMonth = '1M',
  ThreeWeeks = '3w',
  TwoWeeks = '2w',
  OneAndHalfWeek = '1.5w',
  TenDays = '10d',
  OneWeek = '1w',
  SixDays = '6d',
  FiveDays = '5d',
  HundredHours = '100h',
  FourDays = '4d',
  HalfWeek = '0.5w',
  ThreeDays = '3d',
  TwoDays = '2d',
  OneDay = '1d',
  TwentyHours = '20h',
  EighteenHours = '18h',
  FifteenHours = '15h',
  TwelveHours = '12h',
  TenHours = '10h',
  EightHours = '8h',
  SixHours = '6h',
  FiveHours = '5h',
  FourHours = '4h',
  ThreeHours = '3h',
  TwoHours = '2h',
  HundredMinutes = '100m',
  SeventyFiveMinutes = '75m',
  OneHour = '1h',
  FiftyMinutes = '50m',
  FortyMinutes = '40m',
  ThirtyMinutes = '30m',
  TwentyMinutes = '20m',
  FifteenMinutes = '15m',
  TenMinutes = '10m',
  EightMinutes = '8m',
  SixMinutes = '6m',
  FiveMinutes = '5m',
  FourMinutes = '4m',
  ThreeMinutes = '3m',
  TwoMinutes = '2m',
  OneMinute = '1m',
  // New for TPTs
  HundredSixtyHours = '160h',
  HundredFiftySixHours = '156h',
  HundredFiftyTwoHours = '152h',
  HundredFiftyHours = '150h',
  HundredFortySixHours = '146h',
  HundredFortyFourHours = '144h',
  HundredThirtySixHours = '136h',
  HundredThirtyFourHours = '134h',
  HundredThirtyTwoHours = '132h',
  HundredThirtyHours = '130h',
  HundredTwentyEightHours = '128h',
  HundredTwentySixHours = '126h',
  HundredFourteenHours = '114h',
  HundredTwelveHours = '112h',
  HundredTenHours = '110h',
  HundredEightHours = '108h',
  HundredSixHours = '106h',
  NinetyTwoHours = '92h',
  NinetyHours = '90h',
  EightyEightHours = '88h',
  EightySixHours = '86h',
  EightyFourHours = '84h',
  EightyHours = '80h',
  SeventyEightHours = '78h',
  SeventySixHours = '76h',
  SeventyFiveHours = '75h',
  SeventyThreeHours = '73h',
  SeventyTwoHours = '72h',
  SixtyEightHours = '68h',
  SixtySixHours = '66h',
  SixtyFiveHours = '65h',
  SixtyThreeHours = '63h',
  SixtyHours = '60h', // 2.5 days
  FiftyEightHours = '58h',
  FiftySevenHours = '57h',
  FiftySixHours = '56h',
  FiftyFiveHours = '55h',
  FiftyFourHours = '54h',
  FiftyThreeHours = '53h',
  FiftyTwoHours = '52h',
  FiftyHours = '50h',
  FortySixHours = '46h',
  FortyFiveHours = '45h',
  FortyFourHours = '44h',
  FortyThreeHours = '43h',
  FortyTwoHours = '42h',
  FortyHours = '40h',
  ThirtyEightHours = '38h',
  ThirtySixHours = '36h',
  ThirtyHours = '30h',
  TwentyNineHours = '29h',
  TwentyEightHours = '28h',
  TwentySevenHours = '27h',
  TwentySixHours = '26h',
  TwentyThreeHours = '23h',
  TwentyTwoHours = '22h',
  TwentyOneHours = '21h',
  NineteenHours = '19h',
  FourteenHours = '14h',
  ElevenHours = '11h',
  NineHours = '9h',
  SevenHours = '7h',
}
